<template>
  <div>
        <b-modal id="modal-sm" size="md" v-model="loading" no-close-on-esc no-close-on-backdrop hide-header-close hide-footer>
        <div slot="default">
        <div class='alert alert-danger' role='alert' > Searching allocation data , please wait.... <br>  </div>

        <!-- Auth :{{IsAuth}} -->
        <!-- <bar-loader class="custom-class" :color="color" :loading="loading" :size="size" :sizeUnit="unit"></bar-loader>  -->
        <div class="text-center justify-content-center row col-12">
            <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
            <rise-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Risesize" :sizeUnit="unit"></rise-loader> 
            <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
          
        </div>          
        <!-- <div class='alert alert-danger' role='alert' > Your session has expired. please Login again to restore your session. <br>  </div> -->
        </div>  
    </b-modal>
    <b-modal
      id="editModal"
      v-model="showEditModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ok-variant
      cancel-variant
      hide-footer
      header-class="PopUpHeader"
      :body-bg-variant="PopUpVar.bodyBgVariant"
      :body-text-variant="PopUpVar.bodyTextVariant"
      :footer-bg-variant="PopUpVar.footerBgVariant"
      :footer-text-variant="PopUpVar.footerTextVariant"
    >
      <UpdateAllocation
        v-if="showEditModal == true"
        :UserData="UserData"
        @finished="finished"
      ></UpdateAllocation>
      <template slot="modal-header" slot-scope="{ close }">
        <div>
          <small class="PopUpTitle w-100 text-left">Update Allocation</small>
        </div>
        <!-- <div v-show="Button=='Edit'"></div> -->
      </template>
    </b-modal>

    <Subtitle v-bind:ServiceID="this.AppServiceID">
      <template v-slot:header>
        <i class="fas fa-fill-drip"></i><b>Manage Vaccine Allocations:</b>
      </template>
    </Subtitle>
    <form class="card p-0 mb-1" id="SearchForm">
      <div class="row">
        <div class="col-8">
          <div class="card">
            <div
              class="card-header d-flex align-items-center"
              style="height: 2rem; text-align: left"
            >
              <h5>
                <small class="text-muted"
                  ><b
                    ><i class="fas fa-search-plus"></i>Search: Allocation</b
                  ></small
                >
              </h5>
            </div>
            <div class="form-row p-2">
              <div class="form-group col-sm-2">
                <label for="inputPassword4" class="label-small"
                  >Cut-off Date:</label
                >
                <div>
                  <datepicker
                    class="servdatapick"
                    :typeable="typable"
                    :open-date="new Date()"
                    v-model="cDate"
                    :format="DateFormat"
                    id="toDate"
                    :bootstrap-styling="true"
                    :input-class="datapickClass"
                    name="toDatepicker"
                    :disabledDates="{
                      days: [0, 1, 3, 4, 5, 6],
                    }"
                  ></datepicker>
                </div>
                <div class="row" v-show="$v.cDate.$error">
                  <div class="col-sm-12">
                    <small class="sml-red" v-if="!$v.cDate.required"
                      >Cut-off Date is required.</small
                    >
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-6">
                <label for="inputEmail4" class="label-small"
                  >Search Community and Covid Zones:</label
                >
                <div class="">
                  <vue-bootstrap-typeahead
                    :inputClass="TypeHeadClass"
                    id="clinicSel"
                    ref="zoneRef"
                    @input="CovidZonetextChanged"
                    v-model="SelectedCovidZone"
                    :data="CovidZones"
                    @hit="
                      selectedZone = $event;
                      searched = false;
                    "
                    :serializer="(item) => item.community + '-' + item.zone"
                    textVariant=".text-primary"
                    placeholder="Search Community and Covid Zones"
                    size="sm"
                    backgroundVariant="bg-light"
                    :maxMatches="20"
                    updateOn="blur"
                  >
                    <template slot="prepend">
                      <span
                        class="input-group-text form-control-xs"
                        style="font-size: 0.7rem"
                        ><i class="fas fa-search fa-sm"></i
                      ></span>
                    </template>
                  </vue-bootstrap-typeahead>
                </div>
              </div>
              <div class="form-group col-sm-2">
                <label for="inputPassword4" class="label-small"
                  >Dosage Qty:
                </label>
                <div class="">
                <input
                onkeydown="javascript: return event.keyCode === 8 ||
                event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                type="number"
                min="1"
                max="300"
                v-model="selectedQty"/>
                  <!-- <select
                    id="override"
                    v-model="selectedQty"
                    class="form-control form-control-xs select-css"
                  >
                    <option
                      v-for="option in qty"
                      v-bind:value="option.id"
                      :key="option.id"
                    >
                      <strong>{{ option.text }} </strong>
                    </option>
                  </select> -->
                </div>
                <div class="row" v-show="$v.selectedQty.$error">
                  <div class="col-sm-12">
                    <small class="sml-red" v-if="!$v.selectedQty.val"
                      >invalid Qty.</small
                    >
                  </div>
                </div>
              </div>

              <div class="form-group col-sm-2">
                <label for="inputPassword4" class="label-small"> </label>
                <div class="">
                  <button
                    type="button"
                    class="btn btn-primary btn-sml mt-1"
                    @click="PharmacyAllocation"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
 
        <div class="col-4 pl-0">
          <div class="card">
            <div
              class="card-header d-flex align-items-center pl-1"
              style="height: 2rem; text-align: left"
            >
              <h5>
                <small class="text-muted"
                  ><b
                    ><i class="fas fa-clinic-medical"></i>Upload : Batch
                    Allocation</b
                  ></small
                >
              </h5>
            </div>
            <div class="form-group row">
              <div class="col-sm-7">
                {{ popupText }}
                <vue-upload-multiple-image
                  :maxImage="1"
                  :accept="ImageType"
                  :showPrimary="false"
                  :popupText="popupText"
                  :primaryText="primaryText"
                  :dragText="dragText"
                  :browseText="browseText"
                  :showEdit="false"
                  :showAdd="false"
                  :multiple="false"
                  @upload-success="uploadImageSuccess"
                  @before-remove="beforeRemove"
                  @edit-image="editImage"
                  :data-images="images"
                  idUpload="myIdUpload"
                  editUpload="myIdEdit"
                  ref="img"
                ></vue-upload-multiple-image>
                <!-- <button @click="uploaddoc">Submit</button> -->
              </div>
              <div
                class="
                  col-sm-5
                  d-flex
                  align-items-center
                  justify-content-center
                  mt-auto
                "
                style="text-align: bottom"
              >
                <button
                  v-on:click="DownloadErrorFile"
                  type="button"
                  class="btn btn-primary btn-sml mt-1"
                  :class="btnclass"
                >
                  Download Error File
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div id="Alloc" class="mt-2" v-if="allocation.length">
      <form class="card p-1 mb-1" id="alloc">
        <v-client-table
          :columns="columns"
          v-model="allocation"
          :options="options"
        >
          <div slot="afterFilter" class="VueTables_Adduser mr-3 mt-3 ml-3">
            <download-excel
              class="pointer"
              :data="allocation"
              type="csv"
              name="PharmacyAllocations.csv"
              :fields="{
                pharmacyno: 'pharmacyno',
                pharmacy: 'pharmacyname',
                cutoffdate: 'cutoffdate',
                productdescription: 'productdescription',
                doseqty: 'doseqty',
                allocweek: 'allocweek',
                deliverydate: 'deliverydate',
                zone: 'zone',
                community: 'community',
                'supplier no': 'vendorid',
              }"
            >
              <span
                class="
                  text-muted
                  pointer
                  fas
                  fa-cloud-download-alt
                  text-muted
                  fa-lg
                  mt-2
                "
              ></span
              ><b class="text-muted ml-2">Download Csv</b>
            </download-excel>
          </div>
          <span
            class="pointer"
            v-on:click="EditPopup(props.row)"
            slot="edit"
            slot-scope="props"
            ><i class="far fa-edit"></i
          ></span>
        </v-client-table>
      </form>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import LayoutDefault from "@/Common/Default/DefaultLayout.vue";
import Subtitle from "@/Common/Default/SubTitle.vue";
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import { isNullOrUndefined } from "util";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Vuelidate from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import UpdateAllocation from "@/components/DPEBB/Ministry/UpdateAllocation.vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import { RingLoader } from "@saeris/vue-spinners";
import { RiseLoader } from "@saeris/vue-spinners";
import {
  required,
  minLength,
  maxLength,
  between,
  withParams,
  numeric,
} from "vuelidate/lib/validators";
import { getEventListener } from "stream";
const alphaNum = helpers.regex("alphaNum", /^\d{1,5}\s\w*/);
Vue.use(Vuelidate);
export default {
  name: "DentalHome",
  props: { LeadAssessor: false, ServiceID: "" },
  data: function () {
    return {
      loading: false,
      size: 150,
      Ringsize: 30,
      Risesize: 12,
      margin: "2px",
      unit: "px",
      color: "#bada55",
      selectedQty: "",
      qty: [],
      selectedZone: "",
      UserData: "",
      showEditModal: false,
      cDate: "",
      typable: false,
      ErrorFileExist: false,
      SelectedCovidZone: "",
      CovidZones: [],
      TypeHeadClass: "form-control form-control-xs my-0",
      fromDate: "",
      toDate: "",
      serviceDate: "",
      DateFormat: "",
      datapickClass: "form-control form-control-xs my-0",
      docName: "VaxAllocLoad_DataError",
      //ImageType: "text/csv,application/vnd.ms-excel",
      ImageType: "text/csv",
      popupTitle: "",
      PopAddEditTitle: "Add Service Code Form",
      popupText: "",
      primaryText: "",
      PaidByThirdPArty: false,
      dragText: "Upload Allocation File",
      browseText: "Click Here",
      images: [],
      fileList: "",
      postdate: "",
      myVueDropzone: "",
      pdf: undefined,
      mode: "",
      canSave: true,
      clinic: [],
      ClinicNo: "",
      TypeHeadinptClass: "form-control",
      ShowFacilities: false,
      Facilities: "",
      SelectedFacility: "",
      SelectFacId: "",
      Patient: "",
      Risks: "",
      RisFactors: "",
      datapickClass: "form-control form-control-xs my-0",
      PopUpVar: PopUpVariant,
      effectiveDate: "",
      HSN: "",
      ProviderNo: "",
      Showinfo: false,
      showError: false,
      MsgPopup: false,
      showModal: false,
      columns: [
        "edit",
        "pharmacyno",
        "pharmacyname",
        "productdescription",
        "doseqty",
        "allocweek",
        "deliverydate",
        //"cutoffdate",
        "zone",
        "community",
        //"vendorid"
      ], //, "comments",],//  , "productid"],
      allocation: [],
      options: {
        templates: {
          allocweek(h, row) {
            return moment(row.allocweek, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
          deliverydate(h, row) {
            return moment(row.deliverydate, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
          // cutoffdate(h, row) {
          //   return moment(row.cutoffdate, "YYYY-MM-DD").format("YYYY/MM/DD");
          // },
        },
        texts: {
          count: "",
          first: "First",
          last: "Last",
          limit: "Records:",
          page: "Page:",
          noResults: "Allocation data not found.",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns",
        },
        sortIcon: {
          base: "fas",
          is: "fa-sort",
          up: "fa-sort-up",
          down: "fa-sort-down",
        },
        perPage: 10,
        perPageValues: [10, 20, 40, 80, 100],
        headings: {
          edit: "Update",
          pharmacyno: "Pharmacy No",
          pharmacyname: "Pharmacy Name",
          allocweek: "Allocation Week",
          deliverydate: "Delivery Date",
          doseqty: "Dosage Qty",
          productdescription: "Vaccine",
          zone: "Zone",
          community: "Community",
          //vendorid: "Supplier Account"
          //cutoffdate: "Cut-off Date",
        },
       
        sortable: [
          "pharmacyno",
          "pharmacyname",
          "productdescription",
          "doseqty",
          "zone",
          "community",
          "vendorid",
          "allocweek",
           "deliverydate"
        ],
        //  filterable: ["name"],
        //filterable: "",
        filterable: [
          "pharmacyno",
          "pharmacyname",
          "productdescription",
          "doseqty",
          "zone",
          "community",
          "vendorid",
        ],
      },
    };
  },
  watch: {},
  components: {
    RingLoader,
    RiseLoader,
    VueUploadMultipleImage,
    Card,
    CardBody,
    TileNote,
    Datepicker,
    Subtitle,
    UpdateAllocation,
  },
  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },
  computed: {
    UserName() {
      return !this.$store.getters.GetCurrentUser
        ? false
        : this.$store.getters.GetCurrentUser;
    },

    btnclass() {
      if (this.ErrorFileExist) {
        return "btn btn-primary btn-sml mt-1";
      } else return "btn btn-outline-primary btn-sml mt-1";
      //return darkMode ? 'dark-theme' : 'light-theme';
    },
  },
  methods: {
    finished() {
      this.PharmacyAllocation();
      this.showEditModal = false;
    },
    EditPopup: function (Rowdata) {
      // this.Button='Edit';
      this.UserData = Rowdata;
      this.showEditModal = true;
    },
    CovidZonetextChanged() {
      if (this.SelectedCovidZone == "" || this.SelectedCovidZone == null) {
        this.selectedZone = null;
      }
    },
    GetErrorFileExist() {
      var vm = this;
      axios
        .get("SaskHealthApi/Codes/GetErrorFileExist", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          //params,
        })
        .then(function (response) {
          //console.log(response.data);
          if (response.data == "TRUE") {
            vm.ErrorFileExist = true;
          }
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {});
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.csv"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    uploadImageSuccess(formData, index, filelist) {
      this.fileList = filelist;
      ////console.log('data = ', formData)
      ////console.log('index = ', index)
      ////console.log('filelist = ', filelist)
      if (
        (filelist[0].Filetype == "application/vnd.ms-excel" ||
          filelist[0].Filetype == "text/csv") &&
        filelist[0].name == "VaxAllocLoad.csv"
      ) {
        this.popupText = this.fileList[0].name;
        ////console.log("is csv OK");
        this.uploaddoc();
      } else {
        this.showMsg(
          "File type or file name not allowed. Please upload the allocation file again.",
          "",
          "File Upload Error"
        );
        this.images = [];
      }
      // _.forEach(filelist, function(value, key) {
      //   //console.log(value.path.split(',')[1]);
      // });
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   //console.log(response)
      // })
      ////console.log("file List", this.fileList);
    },
    showMsgBox(msg, data, MethodNo, done) {
      var vm = this;
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: "Please Confirm",
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          cancelVariant: "default",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          ////console.log(value)
          if (value) {
            if (MethodNo == 2) {
              vm.popupText = "";
              done();
              //vm.DelConfirm = this.boxTwo;
            }
            if (MethodNo == 1);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    beforeRemove(index, done, fileList) {
      this.showMsgBox(
        "Are you sure you want to delete the file ? ",
        "",
        2,
        done
      );
    },
    editImage(formData, index, fileList) {
      this.popupText = fileList[0].name;
      this.uploaddoc();
      ////console.log('edit data', formData, index, fileList)
    },
    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    uploaddoc() {
      var vm = this;
      var url = "/SaskHealthApi/Codes/PostAllocationFile/";
      var bodyFormData = new FormData();
      var im = [];
      _.forEach(vm.fileList, function (value, key) {
        im.push({
          DocName: value.name,
          DocType: value.path.split(",")[0].split(";")[0].split(":")[1],
          DocImage: value.path.split(",")[1],
        });
      });
      bodyFormData.append("imgdata", JSON.stringify(im));
      axios({
        method: "post",
        url: url,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + vm.$store.getters.GetAccessToken,
        },
        data: bodyFormData,
      })
        .then(function (response) {
          //console.log(response);
          //   if (response.status == 200) {
          // if(response.data.statusid==1)
          // vm.BtnSubmitdisabled=true;
          vm.showMsg(response.data, "", "Allocation File");
          //}
        })
        .catch(function (er) {
          //console.log(er);
          if (er.status == 400) {
            vm.showMsg(
              "Network Error, please contact system admin for more detail.",
              "",
              "Allocation File Error"
            );
          }

          if (er.status == 500) {
            if (er.data.message.length > 0) {
              //console.log("here");
              vm.showMsg(er.data.message, "", "Allocation File Error");
            } else {
              vm.showMsg(
                "Network Error, please contact system admin for more detail.",
                "",
                "Allocation File Error"
              );
            }
          }
          ////console.log(er);
        })
        .then(function () {});
    },
    enableSave(file, response) {
      // this.$refs.myVueDropzone.removeAllFiles(this.pdf)
      if (file.accepted) {
        // if(!(this.pdf==undefined))
        // his.$refs.myVueDropzone.removeFile(this.pdf)

        var fileReader = new FileReader();
        var base64;
        fileReader.onload = (fileLoadedEvent) => {
          base64 = fileLoadedEvent.target.result;
          //this.pdf.dataURL= base64; this.pdf.dataURL= base64;
        };
        fileReader.readAsDataURL(file);
        if (fileReader.result) {
          this.doc64String = base64.split(";")[1].split(",")[1];
          // USE the DATAURL
          //clearInterval(checkIfReady);
        }

        // Checks every second for the dataURL.
        var checkIfReady = setInterval(() => {
          // If there is it logs it.
          if (fileReader.result) {
            this.doc64String = base64.split(";")[1].split(",")[1];
            // //console.log( this.doc64String );
            // USE the DATAURL

            clearInterval(checkIfReady);
          }
          // Stops checking after 10 seconds.
          setTimeout(() => {
            clearInterval(checkIfReady);
          }, 10000);
        }, 1000);

        this.canSave = true;
        this.pdf = file;
        //console.log("This PDF = " + this.pdf);
        this.docType = file.type;
        this.docName = file.name;
        this.canSave = true;
      } else {
        this.$refs.myVueDropzone.removeAllFiles();
      }
    },
    DownloadErrorFile: function () {
      var vm = this;
      var url = "/SaskHealthApi/Codes/GetErrorFile?_=";
      axios
        .get(url + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          //  params,
        })
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "VaxAllocLoadErr.csv"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (er) {
          if (er.status == 404) {
            //console.log("at 404");
            vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "Allocation File Error"
            );
          } else if (er.status == 400) {
            vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "Allocation File Error"
            );
          } else if (er.status == 500) {
            vm.showMsg(
              "Network Error: Please contact system admin for more detail.",
              "",
              "Allocation File Error"
            );
          }
          //console.log(er);
        });
    },
    GetClinicInfo() {
      var vm = this;
      var params = new URLSearchParams();
      //console.log("username " + vm.UserName);
      params.append("username", vm.UserName);
      axios
        .get("SaskHealthApi/Codes/GetClinicinfo", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.clinic = response.data;
          vm.ClinicNo = vm.clinic[0].clinicno;
          ////console.log("clinic no " + vm.ClinicNo);
        })
        .catch(function (er) {
          ////console.log(er)
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {});
    },
    GetCovidZones() {
      var vm = this;
      vm.CovidZones = [];
      // var params = new URLSearchParams();
      // //console.log("username " + vm.UserName);
      // params.append("username", vm.UserName);
      axios
        .get("SaskHealthApi/Codes/GetCovidZones", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          //params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.CovidZones = response.data;
          //vm.ClinicNo = vm.clinic[0].clinicno;
          ////console.log("clinic no " + vm.ClinicNo);
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {});
    },

    GetQty() {
      var vm = this;
      vm.qty = [];
      var params = new URLSearchParams();
      params.append("name", "ALO");
      axios
        .get("SaskHealthApi/Codes/GetLookups", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.qty = response.data;
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {
          // vm.qty.unshift({ id: "-1", text: "Select qty", sort: 4 });
          // vm.selectedQty = -1;
        });
    },

    PharmacyAllocation() {
      var vm = this;
      vm.allocation = [];
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
        vm.loading=true;
        ////console.log("org date " + vm.cDate);
        ////console.log(" zone =" + vm.selectedZone.id);
        var params = new URLSearchParams();
        // var cuttoff = moment(vm.cDate, "YYYY-MM-DD").format(
        //     "YYYYMMDD"
        //   );
        var cuttoff = moment(vm.cDate, "YYYY-MM-DD").format("YYYY-MM-DD");
        if (
          vm.selectedZone == "" ||
          vm.selectedZone == null ||
          vm.selectedZone == undefined
        ) {
          params.append("CovidZoneID", "0");
        } else {
          params.append("CovidZoneID", vm.selectedZone.id);
        }
        params.append("cuttoffdate", cuttoff);
        params.append("qtyReq", vm.selectedQty);
        axios
          .get("SaskHealthApi/Codes/GetAllocations", {
            headers: { Authorization: "Bearer " + localStorage.access_token },
            params,
          })
          .then(function (response) {
            vm.allocation = response.data;
          })
          .catch(function (er) {
            if (er.status == 500) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Allocation Confirmation"
              );
            } else if (er.status == 400) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Allocation Confirmation"
              );
            }
          })
          .then(function () {
            vm.loading =false;
            if (vm.allocation.length == 0) {
              
              vm.showMsg(
                "Vaccine Allocation not found.",
                "",
                "Allocation Confirmation"
              );
            }
          });
      }
    },

    Show() {
      this.Showinfo = true;
    },
    ClosePopup() {
      this.showError = false;
    }, //FHRegisterEDS

    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    validateQty(){
        if(this.selectedQty != null || this.selectedQty !="" || this.selectedQty != undefined)
        {
          ////console.log('here not null')
          if(this.selectedQty >=0)
          {
            ////console.log(' > 0')
            return true;
          }
          else
          {
            ////console.log(' < less 0')
              return false;
          }
        }
        else
        {
          if(!isNaN(this.selectedQty))
          {
            return false;
          }
          else
          return true;
        }
        
    }
  },

  created: function () {
    this.$emit("update:layout", LayoutDefault);
    this.AppServiceID = this.$store.getters.GetDPEBBServiceID;
    this.DateFormat = this.$store.getters.GetDateFormat;
    this.ServiceDate = moment(new Date()).format("YYYY/MM/DD");
    this.GetClinicInfo();
    this.GetCovidZones();
    this.GetErrorFileExist();
    //this.GetQty();
  },
  beforeCreate: function () {
    this.$store.dispatch("AddServiceID", this.$store.getters.GetDPEBBServiceID);
    this.$store.dispatch("GetMenuItems", this.$store.getters.GetDPEBBServiceID);
  },
  mounted: function () {
    //this.$refs.SearchClinic.inputValue = 'Some value'
    this.$nextTick(function () {});
  },

  validations() {
    return {
      selectedQty : {
         val: (value) => this.validateQty(),
      },
      // selectedProvider : {
      //   required,
      // },
      // HSN: {
      //   required,
      //   numeric,
      //   minLength: minLength(9),
      // },
      cDate: {
        required,
      },
      // effectiveDate: {
      //   val: (value) => this.ValidateEffectDate(),
      // },
      // Risks: {
      //   val: (value) => this.ValidateRisk(),
      // },
      // SelectFacId: {
      //   val: (value) => this.ValidateFacility(),
      // },
    };
  },
};
</script>
<style scopped>
.ulClass {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0px !important;
}
.liClass {
  border: 1px solid;
  margin-bottom: 5px;
  border-radius: 5px;
  margin-right: 5px;
  padding: 0 5px;
}
.file-name {
  min-width: 150px;
  font-size: 13px;
}
.uploaded-date {
  font-size: 12px;
}
.upload-progress {
  font-size: 12px;
}
.file-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0px !important;
}
.file-details {
  margin-bottom: 0px !important;
}

.row.no-gutter [class*="col-"] {
  padding-right: 1px;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0px 15px;
  margin-bottom: -1px;
  border: 1px solid #ddd;
  background-color: blue;
  line-height: 1em;
}
/* remove right padding from first column */
/* .row.no-gutter [class*='col-']:first-child {
  padding-right:5px;
} */
/* remove left padding from first column */
/* .row.no-gutter [class*='col-']:last-child {
  padding-left:5px;
} */

/* only for column content visible */
.col-lg-1 > div {
  background-color: #ddd;
}

#docimg {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 10px; */
}
#line {
  border-top: 1px solid rgba(7, 14, 109, 0.25);
  /* border-bottom:1px solid #c00;
  border-bottom: 1px solid rgba(255,255,255,.25); */
}
.select-css {
  display: block;
  font-size: 14px;
  /* font-family: sans-serif; */
  font-weight: 600;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  /* appearance: none; */
  background-color: #fff;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}
.select-css option {
  font-weight: normal;
}
#ServiceCodeGrid .VuePagination__count {
  visibility: hidden;
  height: 0px;
}
#ServiceCodeGrid .pagination {
  height: 0px;
}
/* #ServiceCodeGrid tr td:nth-child(2) {
    width: 9.5rem !important;
    padding:3px !important;
    /* margin:0rem !important;
}  */

.highlight {
  background-color: #fff2ac;
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
}
.bd-highlight {
  /* background-color: rgba(86,61,124,0.15); */
  /* border: 1px solid rgba(86,61,124,0.15); */
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
  /* background-image: linear-gradient(to right, #ac9732ad 0%, #cebc5985 100%); */
  /* text-decoration-line: underline; */
  font-weight: bold;
  padding: 0.4rem;
  margin: 0rem !important;
}

.cov {
  font-size: 1.3rem;
  font-weight: bolder;
  /* padding: .2rem; */
  margin: 0rem !important;
}
</style>